import ProjectsSearchPanel from './ProjectsSearchPanel';
export default ProjectsSearchPanel;
